import React from 'react'
import styled from 'styled-components'
import PageBreadcrumbs from 'organization/Event/Page/PageBreadcrumbs'
import Header from 'lib/ui/layout/Header'
import {Title} from 'lib/ui/typography'
import Page from 'organization/Event/Page'
import Tile from 'organization/Event/HelpPage/Tile'
import {
  BookIcon,
  CommentsIcon,
  CalendarIcon,
  FacebookIcon,
  GraduationCapIcon,
  EnvelopeIcon,
} from 'lib/ui/Icon'

export default function HelpPage() {
  return (
    <PageBreadcrumbs page="Help">
      <Page>
        <Header>
          <Title>Help</Title>
        </Header>
        <Grid>
          <Tile icon={<BookIcon />} title="Knowledge Base">
            Find answers in our knowledge base at{' '}
            <Link href="https://help.obv.io" target="_blank" rel="noreferrer">
              help.obv.io
            </Link>
          </Tile>
          <Tile icon={<CommentsIcon />} title="Chat Support">
            Available Monday through Friday,
            <br />
            9:00 AM to 5:00 PM ET.
          </Tile>
          <Tile icon={<CalendarIcon />} title="Weekly Q&A Call">
            Join us on Zoom every Wednesday, 5:00 PM to 7:00 PM ET at{' '}
            <Link href="https://update.obv.io" target="_blank" rel="noreferrer">
              update.obv.io
            </Link>
            . Questions can be pre-submitted on the dashboard.
          </Tile>
          <Tile icon={<FacebookIcon />} title="Facebook Group">
            Join the conversation in our{' '}
            <Link
              href="https://www.facebook.com/groups/obvioapp"
              target="_blank"
              rel="noreferrer"
            >
              Facebook group
            </Link>
            .
          </Tile>
          <Tile icon={<GraduationCapIcon />} title="Onboarding Workshop">
            Get up to speed with our{' '}
            <Link
              href="https://hub-8l0mj6m40v.membership.io/"
              target="_blank"
              rel="noreferrer"
            >
              onboarding workshop
            </Link>
            .
          </Tile>
          <Tile icon={<EnvelopeIcon />} title="Email Support">
            Reach us anytime at{' '}
            <Link href="mailto:help@obv.io">help@obv.io</Link>
          </Tile>
        </Grid>
      </Page>
    </PageBreadcrumbs>
  )
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${(props) => props.theme.spacing[4]};

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`

const Link = styled.a`
  color: ${(props) => props.theme.colors.primary};
`
